import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { BUILD_ORDER_FOR_TABLE_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_BUILD_ORDERS: TypedDocumentNode<Data, Variables> = gql`
  ${BUILD_ORDER_FOR_TABLE_FRAGMENT}

  query getBuildOrders($first: Int, $last: Int, $sort: BuildOrderSortInput, $terms: [String!]) {
    buildOrders(first: $first, last: $last, sort: $sort, terms: $terms) {
      nodes {
        ...BuildOrderForTableFragment
      }

      totalCount
    }
  }
`
